<template>
  <div>
    <ca-heading text="Responsáveis SEFIP" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">
          Novo responsável
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col>
        <ca-async-content-wrapper
          :key="wrapperKey"
          :on-fetch="getResponsibleList"
          :on-fetch-success="setResponsibleList">
          <ca-table v-if="responsibleList">
            <ca-tr slot="header">
              <ca-th>Nome</ca-th>
              <ca-th>Tipo de inscrição</ca-th>
              <ca-th>Inscrição</ca-th>
              <ca-th>Compartilhado</ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr
              v-for="(responsible, index) in responsibleList.content"
              :key="index"
              @click="onView(responsible.id)">
              <ca-td>{{ responsible.name }}</ca-td>
              <ca-td>{{ responsible.registerType.description }}</ca-td>
              <ca-td>{{ responsible.register }}</ca-td>
              <ca-td>{{ responsible.shared ? 'Sim' : 'Não' }}</ca-td>
              <ca-td>
                <ca-button
                  class="ca-u-margin-right"
                  size="small"
                  @click.stop="onEdit(responsible.id)">
                  Editar
                </ca-button>
                <ca-button
                  size="small"
                  @click.stop="onDelete(index, responsible.id)">
                  Remover
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col class="ca-u-text-center">
        <ca-pagination
          v-if="responsibleList.totalPages > 1"
          v-model="currentPage"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center"
          :total-pages="responsibleList.totalPages">
        </ca-pagination>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getResponsibleList, deleteResponsible } from './responsibleService';
import { getErrorMessageFromResponse } from '../../../packages/common';
import ResponsibleFormRollover from './ResponsibleFormRollover.vue';

export default {
  name: 'ResponsiblePage',
  data() {
    return {
      wrapperKey: 0,
      currentPage: 0,
      responsibleList: {},
    };
  },
  methods: {
    getResponsibleList() {
      return getResponsibleList({ page: this.currentPage });
    },
    setResponsibleList(response) {
      this.responsibleList = response;
    },
    onNew() {
      this.$dialogModal(ResponsibleFormRollover, {
        on: {
          completed: () => this.updateList(),
        },
      }).open();
    },
    onView(id) {
      this.$router.push({ name: 'ResponsibleView', params: { id } });
    },
    onEdit(responsibleId) {
      this.$dialogModal(ResponsibleFormRollover, {
        props: { responsibleId },
        on: {
          completed: () => this.updateList(),
        },
      }).open();
    },
    onDelete(index, responsibleId) {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir este responsável?',
        onConfirm: async () => {
          try {
            await deleteResponsible(responsibleId);
            this.$toaster.success('Responsável excluído com sucesso!');
            this.$delete(this.responsibleList.content, index);
          } catch (error) {
            this.$toaster.error(getErrorMessageFromResponse(error));
          }
        },
      });
    },
    updateList() {
      this.wrapperKey++;
    },
  },
};
</script>
